import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "get-information_16",
  "use": "get-information_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"get-information_16\"><path d=\"M8 0a8 8 0 100 16A8 8 0 008 0zm-.5 3a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 017.5 3zM9 12h1v1H6v-1h1V8H6V7h3v5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ba-ui-toolkit/ba-graphics/dist/icons/get-information_16.svg
// module id = 112
// module chunks = 0